import { makeAction, makeReducer } from '@finn-no/redux-actions';
import type { Dispatch } from 'redux';
import { debounce } from 'shared/util/debounce';
import { getApiUrl } from '@/api/apiUrl';
import { fetchOffersForMap } from '@/api/fetcher';
import { ApiActionStatus, type MapOffersResponse, type ThunkResult } from '@/interfaces';
import { filtersToApiQueryParams } from '@/lib/utils/queryParamFilterConversions';
import defaultState from './defaultState';

export const actions = {
    setPending: makeAction<MapOffersResponse>('MAP_RESULT_PENDING', (state) => ({
        ...state,
        status: ApiActionStatus.PENDING,
    })),
    setMapResults: makeAction<MapOffersResponse>('MAP_RESULT_OK', (_, action) => ({
        ...defaultState.mapResults,
        ...action.payload,
        status: ApiActionStatus.OK,
    })),
    setNotModified: makeAction<MapOffersResponse>('MAP_RESULT_NOT_MODIFIED', (state) => ({
        ...state,
        status: ApiActionStatus.OK,
    })),
    setError: makeAction<MapOffersResponse>('MAP_RESULT_ERROR', (state) => ({
        ...state,
        status: ApiActionStatus.ERROR,
    })),
};

export const debouncedFetchMapOffers = debounce(async (fetch: () => Promise<MapOffersResponse | null>, dispatch: Dispatch) => {
    try {
        const data = await fetch();
        if (data) {
            dispatch(actions.setMapResults(data));
        } else {
            dispatch(actions.setNotModified());
        }
    } catch {
        dispatch(actions.setError());
    }
}, 300);

export const fetchMapResults =
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        (payload?: any): ThunkResult<Promise<void>> =>
        async (dispatch, getState): Promise<void> => {
            dispatch(actions.setPending());
            debouncedFetchMapOffers(
                () => fetchOffersForMap(getApiUrl(), filtersToApiQueryParams({ ...getState().filters, ...payload })),
                dispatch,
            );
        };

export default actions;
export const mapResultReducer = makeReducer<MapOffersResponse>(actions);
